import { formatDate } from '@angular/common';
import { Injectable, Injector, inject, signal } from '@angular/core';
import { MessageService } from 'primeng/api';
import { first } from 'rxjs';
import { AuthService } from '../../../Common/Services/auth.service';
import { HttpService } from '../../../Common/Services/http.service';

@Injectable({
  providedIn: 'root',
})
export class ImportService {
  constructor(private readonly httpService: HttpService) {}
  isDataImported: boolean = localStorage.getItem('dataUploadedDate') ? true : false;
  toastShown = signal<boolean>(this.getIsToastShownValue());
  private messageService = inject(MessageService);
  private readonly injector = inject(Injector); 

  getIsToastShownValue(): boolean {
    const value = localStorage.getItem('importDataToastShown');
    return value === 'true';
  }

  uploadFile(file: File) {
    const formData = new FormData();
    formData.append('file', file);
    return this.httpService.post(`uploadFile`, formData);
  }

  showToast() {
     // subscribe to get last uploaded date
     this.injector.get(AuthService).getLastUploadedDate
     .pipe(first()) // Automatically completes/unsubscribes after one value
     .subscribe(date => {
      if (date) {
        const lastImportedDate = formatDate(date, 'MM/dd/yyyy', 'en-US');
        if (lastImportedDate && !this.getIsToastShownValue()) {
          this.toastShown.set(true);
          localStorage.setItem('importDataToastShown', 'true');
          this.messageService.add({
            summary: `Data you are visualizing are old and was uploaded on ${lastImportedDate}, if you wish to set new data please import the latest file from the import menu at sidebar.`,
            life: 7000,
            key: 'headless',
            severity: 'primary',
          });
        }
      }
    });
  }
}
